import { render, staticRenderFns } from "./PaymentButtons.vue?vue&type=template&id=707925a8"
import script from "./PaymentButtons.vue?vue&type=script&lang=js"
export * from "./PaymentButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports